import t from "styled-components";
import e from "../../utils/colors.js";
const i = t.div``, l = t(i)`
  display: flex;
  flex-direction: column;
`, r = t.ul`
  list-style-type: disc;
`, s = t.ol``, a = t.ol`
  list-style-type: lower-alpha;
`, p = t.li`
  letter-spacing: -0.3px;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: ${e.blueGrey};
  margin: 0; // By default, li items don't have margin. However, the base Sitecore file includes a margin-top:20px on list items.
`;
export {
  a as AlphaListContainer,
  l as Container,
  r as DiscListContainer,
  p as ItemContainer,
  s as NumberListContainer,
  i as Wrapper
};
